import { AbstractControl, ValidatorFn } from "@angular/forms";

export function captchaValidator(control: AbstractControl):{ [key: string]: any } {

    let value = control.value;
    
    if (localStorage.getItem("verified")) {
      return null;
    } 
    else { 
      return {"captchaValidator": { value } } 
    }

}

export function captchaValidatorPl(control: AbstractControl):{ [key: string]: any } {

  let value = control.value;
  
  if (localStorage.getItem("verifiedPl")) {
    return null;
  } 
  else { 
    return {"captchaValidatorPl": { value } } 
  }

}

export function numbDots(control: AbstractControl): { [key: string]: any } {

    let numbRegex = /[0-9]{5}\-[0-9]{5}\-[0-9]{2}/i;
    let value = control.value;

    let result = numbRegex.test(value);

    if (result) {
        return null;
    } 
    else {
        return { "numbDots": { value } }
    }
}